// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1eGP7","text":"SelectPayment_text__3BbFM","title":"SelectPayment_title__2NUYR","btn":"SelectPayment_btn__2aXXe"};